import SiteSearch from './site-search';

export default SiteSearch;
